document.addEventListener('DOMContentLoaded', function () {
  const breakpoint = 1024;
  const mobilePanel = document.querySelector('.znt-featured-menu_mobile-panel-list');
  const mobileInfo = document.querySelector('.menu-contact__info');
  const mobileActions = document.querySelector('.header-mobile__actions');
  let disclosures = document.querySelectorAll('.znt-disclosure');

  // The Categories block uses a native <button class="znt--categories-caret-btn">
  // as its toggle (for keyboard access); match it alongside the standard buttons.
  const TRIGGER_SELECTOR = '.znt-disclosure_button, .znt--categories-caret-btn';

  function getPanel(item) {
    return item.querySelector('.znt-disclosure_panel');
  }

  /**
   * 32736 alternative to `inert`: use the HTML `hidden` attribute so closed
   * submenu panels leave the tab order / a11y tree. Avoids iOS slide breakage
   * that `inert` + focus-into-panel caused on mobile.
   */
  function syncPanelHidden(item) {
    const panel = getPanel(item);
    if (!panel) return;
    panel.hidden = !item.classList.contains('znt--open');
  }

  function focusFirstInPanel(item) {
    const panel = getPanel(item);
    if (!panel || panel.hidden) return;
    const focusable = panel.querySelector(
      'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (focusable instanceof HTMLElement) {
      focusable.focus();
    }
  }

  function openMenu(item, button, { moveFocus = false } = {}) {
    item.classList.add('znt--open');
    button.setAttribute('aria-expanded', 'true');
    syncPanelHidden(item);

    if (moveFocus) {
      requestAnimationFrame(() => focusFirstInPanel(item));
    }
  }

  function closeMenu(item, button) {
    item.classList.remove('znt--open');
    if (button) {
      button.setAttribute('aria-expanded', 'false');
    }
    syncPanelHidden(item);
  }

  // ==========================
  // REMOVE OLD BUTTON LISTENERS
  // ==========================
  disclosures.forEach(function (item) {
    const button = item.querySelector('.znt-disclosure_button');
    if (button) {
      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);
    }
  });

  // Re-select after cloning
  disclosures = document.querySelectorAll('.znt-disclosure');

  // Closed panels must not receive focus (visibility:hidden alone is not enough).
  disclosures.forEach(function (item) {
    syncPanelHidden(item);
  });

  // ==========================
  // CLOSE ALL FUNCTION
  // ==========================
  function closeAllMenus() {
    disclosures.forEach(function (el) {
      const btn = el.querySelector(TRIGGER_SELECTOR);
      closeMenu(el, btn);
    });

    if (mobilePanel) {
      mobilePanel.classList.remove('znt--open');
    }

    if (mobileInfo) {
      mobileInfo.classList.remove('znt--open');
    }

    if (mobileActions) {
      mobileActions.classList.remove('znt--open');
    }
  }

  // ==========================
  // MAIN LOGIC
  // ==========================
  disclosures.forEach(function (item) {
    const button = item.querySelector(TRIGGER_SELECTOR);
    if (!button) return;

    // ======================
    // DESKTOP (>=1024)
    // ======================
    if (window.innerWidth >= breakpoint) {
      item.addEventListener('mouseenter', function () {
        closeAllMenus();
        openMenu(item, button);
      });

      item.addEventListener('mouseleave', function () {
        closeMenu(item, button);
      });

      button.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();

          const isOpen = item.classList.contains('znt--open');

          closeAllMenus();

          if (!isOpen) {
            // Desktop keyboard only: move focus into the opened panel (32723).
            openMenu(item, button, { moveFocus: true });
          }
        }

        if (e.key === 'Escape') {
          closeMenu(item, button);
          button.focus();
        }
      });

      document.querySelectorAll('.znt-disclosure_button a').forEach((link) => {
        link.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') {
            e.stopPropagation();
          }
        });

        link.addEventListener('click', function (e) {
          e.stopPropagation();
        });
      });

      item.addEventListener('focusout', function () {
        setTimeout(() => {
          if (!item.contains(document.activeElement)) {
            closeMenu(item, button);
          }
        }, 100);
      });
    }

    // ======================
    // MOBILE (<1024)
    // ======================
    else {
      button.addEventListener('click', function (e) {
        const submenu = getPanel(item);

        // If NO submenu → allow normal link
        if (!submenu) return;

        e.preventDefault();

        const isOpen = item.classList.contains('znt--open');

        closeAllMenus();

        if (!isOpen) {
          // No moveFocus on mobile — focusing into the sliding panel breaks iOS.
          openMenu(item, button, { moveFocus: false });

          if (mobilePanel) {
            mobilePanel.classList.add('znt--open');
          }

          if (mobileInfo) {
            mobileInfo.classList.add('znt--open');
          }

          if (mobileActions) {
            mobileActions.classList.add('znt--open');
          }
        }
      });
    }
  });

  // ==========================
  // BACK BUTTON
  // ==========================
  document.addEventListener('click', function (e) {
    // Match the button itself, not just its inner svg: keyboard activation
    // (Enter/Space) fires the click from the <button>, where e.target is the
    // button — `.back-btn svg` would only match a mouse click on the icon.
    const backBtn = e.target.closest('.back-btn');

    if (backBtn) {
      const openItem = backBtn.closest('.znt-disclosure.znt--open');
      const trigger = openItem?.querySelector(TRIGGER_SELECTOR);
      closeAllMenus();
      if (trigger instanceof HTMLElement) {
        trigger.focus();
      }
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const mobileMenu = document.querySelector('.znt-featured-menu_mobile');
  const body = document.body;
  const breakpoint = 1024;

  if (!mobileMenu) return;

  let lastScrollY = window.scrollY;

  window.addEventListener('scroll', function () {
    if (window.innerWidth <= breakpoint) {
      const currentScrollY = window.scrollY;

      if (currentScrollY < lastScrollY) {
        // Scrolling UP
        mobileMenu.classList.add('znt--fixed-top-mobile');
        body.classList.add('znt--fixed-top-mobile');
      } else {
        // Scrolling DOWN
        mobileMenu.classList.remove('znt--fixed-top-mobile');
        body.classList.remove('znt--fixed-top-mobile');
      }

      lastScrollY = currentScrollY;
    } else {
      mobileMenu.classList.remove('znt--fixed-top-mobile');
      body.classList.remove('znt--fixed-top-mobile');
    }
  });
});

// animation-js

document.addEventListener('DOMContentLoaded', function () {
  const elements = document.querySelectorAll(
    '.top-announcement-bar, .znt-featured-menu_top-row, .znt-featured-menu_bottom-row, .znt-featured-menu_mobile, .bottom-announcement-bar'
  );

  if (!elements.length) return;

  let ignoreScroll = false;

  // ======================
  // SCROLL
  // ======================
  window.addEventListener('scroll', function () {
    if (ignoreScroll) return;

    const currentScroll = window.pageYOffset;

    if (currentScroll === 0) {
      elements.forEach((el) => el.classList.remove('hide-on-scroll'));
    } else {
      elements.forEach((el) => el.classList.add('hide-on-scroll'));
    }
  });

  // ======================
  // SEARCH CLICK
  // ======================
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.search-modal__button');

    if (btn) {
      ignoreScroll = true;

      // optional: reset after modal closes time
      setTimeout(() => {
        ignoreScroll = false;
      }, 500);
    }
  });
});

// When a modal/dialog closes and focus lands on body, restore it to the skip link
// (WCAG 2.4.3 — e.g. subscription dialog submit/close).
document.addEventListener(
  'close',
  function (event) {
    const target = event.target;
    if (!(target instanceof HTMLDialogElement)) return;

    requestAnimationFrame(() => {
      const active = document.activeElement;
      if (active && active !== document.body && active !== document.documentElement) {
        return;
      }

      const skipLink = document.querySelector('.skip-to-content-link, a[href="#MainContent"]');
      if (skipLink instanceof HTMLElement) {
        skipLink.focus();
      } else {
        const main = document.getElementById('MainContent');
        if (main instanceof HTMLElement) {
          if (!main.hasAttribute('tabindex')) {
            main.setAttribute('tabindex', '-1');
          }
          main.focus();
        }
      }
    });
  },
  true
);

// BBFD-415: keep the sticky nav (desktop and mobile) from covering
// "Trending" and the bottom announcement bar when text-spacing overrides
// (WCAG 1.4.12) grow either element's height.
// Grow-only: never sets a value smaller than the static CSS baseline.
(function () {
  const desktopNav = document.querySelector('.znt-featured-menu_container.znt-menu--desktop');
  const mobileNav = document.querySelector('.znt-featured-menu_mobile.znt-menu--mobile');
  const headerGroup = document.getElementById('header-group');
  const bottomBar = document.querySelector('.bottom-announcement-bar');

  // The bottom bar is optional (merchant-toggled section setting); the
  // header-group reservation does not depend on it.
  if ((!desktopNav && !mobileNav) || !headerGroup) return;

  function restoreBaseline() {
    if (headerGroup.style.minHeight) headerGroup.style.minHeight = '';
    if (bottomBar && bottomBar.style.marginTop) bottomBar.style.marginTop = '';
    if (bottomBar && bottomBar.style.top) bottomBar.style.top = '';
  }

  // Both navs are `position: fixed` at every breakpoint in the static CSS;
  // only `display` toggles either off, so both are checked to catch a
  // breakpoint switch and avoid a stale inline override.
  function isActive(el) {
    if (!el) return false;
    const style = getComputedStyle(el);
    return style.position === 'fixed' && style.display !== 'none';
  }

  // Between 1025-1279px the static CSS briefly computes both navs to
  // `display: block` (a separate, out-of-scope duplicate-controls defect).
  // Desktop is checked first so the choice is a fixed priority, not based
  // on prior state, and therefore never thrashes between the two.
  function getActiveNav() {
    if (isActive(desktopNav)) return desktopNav;
    if (isActive(mobileNav)) return mobileNav;
    return null;
  }

  // Reads the static CSS value fresh, ignoring any inline override this
  // script previously wrote, so it stays correct across breakpoint changes.
  function readStaticValue(el, prop) {
    const prev = el.style[prop];
    el.style[prop] = '';
    const value = parseFloat(getComputedStyle(el)[prop]);
    el.style[prop] = prev;
    return Number.isFinite(value) ? value : null;
  }

  function applyOffsets() {
    const activeNav = getActiveNav();
    if (!activeNav) {
      restoreBaseline();
      return;
    }

    const baseReserved = readStaticValue(headerGroup, 'minHeight');
    if (baseReserved === null) return;

    // The nav's `top` is 0 on desktop but merchant-conditional on mobile
    // (a vendor CSS rule pins it to 46px unless a `.has-search` block is
    // present), so its bottom edge is measured directly rather than
    // inferred from `offsetHeight` alone. `getBoundingClientRect().bottom`
    // is not used here because the mobile `hide-on-scroll` class applies a
    // `translateY` transform to this same element, which shifts the rect
    // without changing the nav's actual reserved footprint. Composing the
    // bottom edge from the computed `top` (unaffected by transforms) plus
    // the rect height (unaffected by a pure translation) stays accurate at
    // any scroll offset, transformed or not.
    const navTop = parseFloat(getComputedStyle(activeNav).top);
    const navBottom = (Number.isFinite(navTop) ? navTop : 0) + activeNav.getBoundingClientRect().height;

    // Bar is optional; only read/write it when present and positioned by a
    // rule this script understands: absolute (in-flow, desktop) or fixed
    // (viewport-pinned, mobile).
    let barMode = null;
    let baseBarValue = 0;
    if (bottomBar) {
      const barPosition = getComputedStyle(bottomBar).position;
      if (barPosition === 'absolute') {
        barMode = 'absolute';
        const margin = readStaticValue(bottomBar, 'marginTop');
        baseBarValue = margin === null ? 0 : margin;
      } else if (barPosition === 'fixed') {
        barMode = 'fixed';
        const top = readStaticValue(bottomBar, 'top');
        baseBarValue = top === null ? 0 : top;
      }
    }

    const cushion = barMode ? Math.max(0, baseReserved - baseBarValue) : 0;
    const nextBarOffset = barMode ? Math.max(baseBarValue, navBottom) : 0;

    // On mobile the bar is `position: fixed` against the viewport rather
    // than flowing below header-group, so growth in the bar's own rendered
    // height (its text wrapping under WCAG text spacing) does not show up
    // in navBottom the way it does on desktop. Fold the bar's live bottom
    // edge into the reservation directly so header-group always clears it.
    // `getBoundingClientRect().height` is used instead of `offsetHeight`
    // (a rounded integer) so a sub-pixel bar height cannot leave a
    // fractional overlap below the reservation.
    const barBottom = barMode === 'fixed' ? nextBarOffset + bottomBar.getBoundingClientRect().height : 0;

    const nextReserved = Math.max(baseReserved, navBottom + cushion, barBottom) + 'px';

    if (headerGroup.style.minHeight !== nextReserved) {
      headerGroup.style.minHeight = nextReserved;
    }

    if (bottomBar) {
      if (barMode === 'absolute') {
        const nextMargin = nextBarOffset + 'px';
        if (bottomBar.style.marginTop !== nextMargin) {
          bottomBar.style.marginTop = nextMargin;
        }
        if (bottomBar.style.top) bottomBar.style.top = '';
      } else if (barMode === 'fixed') {
        const nextTop = nextBarOffset + 'px';
        if (bottomBar.style.top !== nextTop) {
          bottomBar.style.top = nextTop;
        }
        if (bottomBar.style.marginTop) bottomBar.style.marginTop = '';
      } else {
        if (bottomBar.style.marginTop) bottomBar.style.marginTop = '';
        if (bottomBar.style.top) bottomBar.style.top = '';
      }
    }
  }

  let rafId = null;
  function scheduleApplyOffsets() {
    if (rafId !== null) return;
    rafId = requestAnimationFrame(function () {
      rafId = null;
      applyOffsets();
    });
  }

  function init() {
    applyOffsets();

    if (typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver(scheduleApplyOffsets);
      if (desktopNav) observer.observe(desktopNav);
      if (mobileNav) observer.observe(mobileNav);
      if (bottomBar) observer.observe(bottomBar);
    }

    window.addEventListener('resize', scheduleApplyOffsets);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
